<template>
  <div id="app">
    <div class="help-tooltip">
      <div class="help-title">
        <div class="help-icon"><i class="icon-help ti-help-alt"></i></div>  
        <div class="help-txt">{{titleChart}}</div>
      </div>
      <div class="help-box" >
        <slot name="content"></slot>      
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

export default {
  props: {
    titleChart: String,
  },
  data () {
    return {
    }
  }
}
</script>
<style>
/*CSS HELP*/  

.help-title{
  border: 1px solid #134F69;
  height: 28px;
  background-color: #627c88;
  font-weight: bold;
  padding: 5px 5px;
  color: #ccc;
}
.help-icon{
  float: left;
  text-align: left;
}
.help-txt{
  text-align: center;
}
.help-box{
  background-color: #2a2a2e;
  height: auto;
  padding: 5px 5px;
  color: #fff;
  font-size: 11px;
}
.help-box p{
  font-size: 11px;
}
.pt-color-green{
  color: #90ed7d;
}
.pt-color-red{
  color: #f45b5b;
}
.pt-color-yellow{
  color: #e4d354;
}

.vue-popover{
  padding:0px!important;
}

/*GERAL DE TODOS OS HELP*/
div[data-popover] {
  background: #2a2a2e;
  color: #000;
  font-size: 12px;
  line-height: 1.5;
  margin: 5px;
  padding: 0px;
  border-radius: 5px;
  
}

/*SETA DE POSIÇÃO DO HELP*/
.vue-popover.dropdown-position-right::before {
  top: 0px!important;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/components/Help.vue